import classNames from 'classnames';
import styles from 'src/pages/PaymentBetaPage/componentsV2/PlanSection/PlanSection.module.scss';
import { SubscriptionPlanInfo } from 'src/types';
import { PlanCard } from 'src/pages/PaymentBetaPage/componentsV2/PlanCard';
import { PlanCard as PlanCardV3 } from 'src/pages/PaymentBetaPage/componentsV3/PlanCard';
import { useFeatureFlagVariantKey } from 'posthog-js/react';
import { PAYMENT_SUBSYSTEM_V3_VARIANT } from 'src/constants';

interface PlanSectionProps {
  sectionPlan: SubscriptionPlanInfo;
  onOpenCheckout: () => void;
}

export const PlanSection = ({
  sectionPlan,
  onOpenCheckout,
}: PlanSectionProps) => {
  const paymentSubsystemVariant = useFeatureFlagVariantKey('payment-subsystem');
  const isShowNewPaymentModalV3 =
    paymentSubsystemVariant === PAYMENT_SUBSYSTEM_V3_VARIANT;
  return (
    <div
      className={classNames(
        isShowNewPaymentModalV3 ? styles.narrowerRoot : styles.root,
        {
          [styles.highlighted]: sectionPlan.plan_kind.includes('30'),
        },
      )}
    >
      <div className={styles.planCardWrapper}>
        {isShowNewPaymentModalV3 ? (
          <PlanCardV3
            sectionPlan={sectionPlan}
            onOpenCheckout={onOpenCheckout}
          />
        ) : (
          <PlanCard sectionPlan={sectionPlan} onOpenCheckout={onOpenCheckout} />
        )}
      </div>
    </div>
  );
};
